module.exports = __webpack_public_path__ + "img/List.238df8e5.svg";